/**
 * Avatar display helpers.
 *
 * @module lib/avatar
 */

/**
 * Derives avatar initials from the user's display name or email.
 *
 * - Two-word names → first letter of each word (e.g. "Jane Doe" → "JD").
 * - Single-word names → first letter (e.g. "Admin" → "A").
 * - No name → first letter of the email address.
 */
export function getUserInitials(name: string | null, email: string): string {
	if (name) {
		const parts = name.trim().split(/\s+/);
		const initials = parts.length >= 2 ? `${parts[0][0]}${parts[1][0]}` : parts[0][0];
		return initials.toUpperCase();
	}
	return email[0].toUpperCase();
}
